<template>
<Toolbar>
  <ToolbarGroup>
    <a href="" @click.prevent="showNewReportPopup" class="btn btn-primary" title="Novo">
      <i class="fa-solid fa-plus"></i>
    </a>
  </ToolbarGroup>
</Toolbar>
<Popup v-model="newReportShown">
<template v-slot:header>
<h2>{{ popupTitle }}</h2>
</template>
<template v-if="objType=='ReportDanger'">
<div class="gen-form-container">
  <div>
    <label>Zaposleni:</label>
    <EmployeeSelect v-model="zaposleni"></EmployeeSelect>
  </div>
</div>
</template>
<template v-slot:actions>
  <button @click.prevent="createNewReport" class="btn btn-primary">Napravite</button>
</template>
</Popup>
</template>

<script>
import api from '@/Util/api';
export default {
  data: ()=>({
    newReportShown: false,
    zaposleni: null,
  }),
  props: {
    newLink: {},
  },
  computed: {
    objType() {
      return this.newLink.params.path[0];
    },
    popupTitle() {
      return this.stores.config.config.data[this.objType]?.labelNew??"Novi izveštaj";
    },
  },
  methods: {
    showNewReportPopup() {
      this.newReportShown=true;
      this.zaposleni=null;
    },
    async createNewReport() {
      var objType=this.newLink.params.path[0];

      var extraData={};
      if (this.objType=="ReportDanger") {
        if (!this.zaposleni)
          return; // TODO show error message
        extraData.zaposleni=this.zaposleni;
      }

      await api.doCreate(objType, {
        klijent: this.stores.auth.currentClient.uuid,
        ...extraData,
      });
      this.newReportShown=false;
      this.$emit("reload");
    },
  },
}
</script>
